var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{ref:"tooltip",attrs:{"popper-class":'action-tooltip no-print' + (!_vm.visibleArrow ? ' no-arrow' : ''),"effect":_vm.effect,"content":_vm.content,"placement":_vm.placement,"disabled":_vm.disabled,"visible-arrow":_vm.visibleArrow,"offset":_vm.offset}},[_vm._t("default"),_vm._t("content",null,{"slot":"content"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }